import React from 'react'
import { BiLeftArrowAlt } from 'react-icons/bi'
import { useHistory } from 'react-router'
import { Box } from './Box'
import { Anchor } from './Anchor'
import { Typography } from './Typography'

type GoBackButtonProps = {
  title?: string
}

export const GoBackButton = ({ title }: GoBackButtonProps) => {
  const history = useHistory()

  return (
    <Anchor onClick={() => history.goBack()}>
      <Box flex flexDirection="row" alignItems="end">
        <Box flex alignItems="center" margin="0 0.25rem 0 0">
          <BiLeftArrowAlt size={18} />
        </Box>
        {title && (
          <Typography variant="body2" margin="0">
            {title}
          </Typography>
        )}
      </Box>
    </Anchor>
  )
}
